import styled from "styled-components";

interface ContainerProps {
  hasBanner?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  max-width: 980px;
  margin-bottom: ${(props) => props.hasBanner && '1.5rem'}
`;
